import {
    CO_GET_SUPPLIERNAME_LISTING,
    CO_GET_SUPPLIERNAME_LISTING_SUCCESS,
    CO_GET_SUPPLIERNAME_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    supplierName: null,
  }
  
  const coSupplierName = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_SUPPLIERNAME_LISTING:
        state = {
          ...state,
          loading: true,
          supplierName: action.payload,
        }
        break
      case CO_GET_SUPPLIERNAME_LISTING_SUCCESS:
        state = { ...state, loading: false, supplierName: action.payload }
        break
      case CO_GET_SUPPLIERNAME_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coSupplierName
  